export default "__VITE_ASSET__BSdiBQss__"